import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AppService, CoreProxyService, CoreTypes, CustomSelectComponent, FormValidatorService, LabelValue } from 'common-cloudstudio';
import { Subscription } from 'rxjs';
import { IncidentService } from '../../../services/incident.service';

export interface ITS_PersonsData extends CoreTypes.ITS_IncidentPersons, CoreTypes.ITS_Persons { 
  VehicleDataID?:number
}

@Component({
  selector: 'app-incident-persons',
  templateUrl:'./incident-persons.component.html',
  styleUrls: ['./incident-persons.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IncidentPersonsComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IncidentPersonsComponent),
      multi: true,
    }
  ]
})
export class IncidentPersonsComponent implements OnInit, OnDestroy, ControlValueAccessor, OnChanges {

  today = new Date();
  minDateInsurance = new Date();
  @ViewChild('search') public searchElementRef: ElementRef;
  @ViewChild('insurance') public _insurance: CustomSelectComponent;
  _data: ITS_PersonsData = {... new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
  @Input('data')
  set data(data) {
    this.writeValue(data);
  }
  get data() {
    return this._data;
  }
  @Input() editing: boolean = false;
  vehiclePersonList: LabelValue<number>[] = [];
  @Output() disableForm = new EventEmitter<boolean>();
  onChange = (_:any) => { }
  onTouch = () => { }

  _errorMessage = "";
  subscriptions: Subscription[] = [];
  isDisabled: boolean;
  searchStatus = 0;

  _insuranceCompanyList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];
  _documentTypeList: LabelValue<number>[] = [];
  _personTypeList: LabelValue<number>[] = [];
  _countries:LabelValue<number>[] = new Array<LabelValue<number>>();
  _assistanceTypeList: LabelValue<number>[] = [];
  _healthConditionList:LabelValue<number>[] = [];
  _hospitalList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];
  _responsibleList: LabelValue<number>[] = [];
  _transferResponsibleList: LabelValue<number>[] = [{label: 'Sin Determinar',value: 0}];

  form: UntypedFormGroup = this.fb.group({
    vehiclePerson:[this.vehiclePersonList[0]],
    documentType: [this._documentTypeList[0] ],
    documentNumber: [ ],
    name:['', ],
    lastName:['', ],
    contactAddress: [''],
    contactCity: [''],
    contactPhone: [''],
    email: [''],
    personType: [this._personTypeList[0]],
    // personDescription: [''],
    country: [],
    assistanceType: [this._assistanceTypeList[0]],
    healthCondition: [this._healthConditionList[0]],
    transfer: [false],
    transferResponsible:[this._transferResponsibleList[0], ],
    hospital: [this._hospitalList[0]],
    destination: [''],
    responsible: [this._responsibleList[0]],
    insuranceCompany: [this._insuranceCompanyList[0]],
    insurancePolicy: [''],
    dateFromInsurance: [new CoreTypes.DateTimeDT()],
    dateToInsurance: [new CoreTypes.DateTimeDT()],
    notes: [''],
  });
  debounceAction;
  debounceUpdate;

  constructor(
    private fb: UntypedFormBuilder,
    public appService: AppService,
    private coreProxyService: CoreProxyService,
    private incidentService: IncidentService,
    private cdRef:ChangeDetectorRef,
    public formValidatorService: FormValidatorService
  ) { }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public validate() {
    let errors: ValidationErrors = {};
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        errors[key] = controlErrors;
      }
    });
    return errors;
  }

  ngOnInit(): void {
    this.subscriptions.push(this.vehiclePerson.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value || value?.value == 0) {
          this._data.VehicleDataID = value?.value;
          this.onInput();
        }
      }, 100);
    }));
    this.subscriptions.push(this.documentNumber.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.DocumentNumber = value;
        this.onInput();
      }, 100);
    }));
    this.subscriptions.push(this.name.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.FirstName = value;
        this.onInput();
      }, 100);
    }));
    this.subscriptions.push(this.lastName.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.LastName = value;
        this.onInput();
      }, 100);
    }));
    this.subscriptions.push(this.documentType.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.DocumentTypeID = value?.value;
          this.onInput();
        }
      }, 100);
    }));
    this.subscriptions.push(this.contactAddress.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.ContactAddress = value;
        this.onInput();
      }, 100);
    }));
    this.subscriptions.push(this.contactCity.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.ContactCity = value;
        this.onInput();
      }, 100);
    }));
    this.subscriptions.push(this.contactPhone.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.ContactPhone = value;
        this.onInput();
      }, 100);
    }));
    this.subscriptions.push(this.email.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.Email = value;
        this.onInput();
      }, 100);
    }));
    this.subscriptions.push(this.country.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.CountryID = value?.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.healthCondition.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.HealthConditionID = value?.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.responsible.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.DamageResponsibilityID = value?.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.insuranceCompany.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.InsuranceCompanyID = value.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.hospital.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value || value?.value == 0) {
          this._data.HospitalID = value.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.personType.valueChanges.subscribe(value => {
      setTimeout(() => {
        if(value?.value) {
          this._data.PersonTypeID = value.value;
          this.onInput();
        }
      }, 100);
    }));

    this.subscriptions.push(this.insurancePolicy.valueChanges.subscribe(value => {
      if(value) {
        this._data.InsurancePolicy = value;
        this.onInput();
      }
    }));
    this.subscriptions.push(this.notes.valueChanges.subscribe(value => {
      if(value) {
        this._data.Notes = value;
        this.onInput();
      }
    }));
    // this.subscriptions.push(this.personDescription.valueChanges.subscribe(value => {
    //   setTimeout(() => {
    //     this._data.OtherPersonType = value;
    //     this.onInput();
    //   }, 100);
    // }));

    this.subscriptions.push(this.assistanceType.valueChanges.subscribe(value => {
      if(value?.value) {
        this._data.AssistanceType = value.value; 
      }
      this.onInput();
    }));

    this.subscriptions.push(this.destination.valueChanges.subscribe(value => {
      setTimeout(() => {
        this._data.Destination = value;
        this.onInput();
      }, 100);
    }));

    this.subscriptions.push(this.transfer.valueChanges.subscribe(value => {
      value ? this.destination.enable() : this.destination.disable();
      setTimeout(() => {
        this._data.Transferred = value;
        if(this.transfer.value === false) {
          this.transferResponsible.setValue(this._transferResponsibleList[0]);
          this._data.TransferredBy = null;
          this._data.Destination = "";
          this.destination.setValue("");
        }
        this.onInput();
      }, 100);
    }));

    this.subscriptions.push(this.transferResponsible.valueChanges.subscribe(value => {
      setTimeout(() => {
        if((value?.value || value?.value == 0) && this.transfer.value) {
          this._data.TransferredBy = value.value ? value.value : null;
        }
        this.onInput();
      }, 100);
    }));

    setTimeout(() => this.loadData(), 100);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  
  ngOnChanges(data: SimpleChanges): void {
    // if(data?.vehiclePersonList?.currentValue) {
    //   this.vehiclePersonList = data.vehiclePersonList.currentValue;
    // }
  }

  onInput() {
    !this.documentNumber.value ? this.disableForm.emit(true) : this.disableForm.emit(false); 
    this.onTouch();
    this.onChange(this._data);
  }

  writeValue(value: any): void {
    this.vehiclePersonList = this.incidentService.vehiclePersonList;
    if (value && Object.keys(value).length !== 0) {
      (typeof value === "object") ? this._data = value : this._data = JSON?.parse(value);
      this.documentNumber.setValue(this._data.DocumentNumber);
      this.name.setValue(this._data.FirstName);
      this.lastName.setValue(this._data.LastName);
      this.contactAddress.setValue(this._data.ContactAddress);
      this.contactCity.setValue(this._data.ContactCity ? this._data.ContactCity : '');
      this.contactPhone.setValue(this._data.ContactPhone);
      this.email.setValue(this._data.Email);
      this.insurancePolicy?.setValue(this._data.InsurancePolicy);
      this.dateFromInsurance?.setValue(this._data?.InsurancePolicyEffectiveSince);
      this.dateToInsurance?.setValue(this._data?.InsurancePolicyValidUntil);
      this.notes.setValue(this._data.Notes);
      // this.personDescription.setValue(this._data.OtherPersonType);
      this.destination.setValue(this._data.Destination);
    } else {
      this._data = {... new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
    }
    this.loadData();
    this.vehiclePersonList = this.incidentService.vehiclePersonList;
    const vehicle = this._data.VehicleDataID ? this.vehiclePersonList.find(x => x.value === this._data.VehicleDataID) : this.vehiclePersonList[0];
    this.vehiclePerson.setValue(vehicle);
    this._data?.TransferredBy || this._data?.Destination || this._data.HospitalID ? this.transfer.setValue(true) : this.transfer.setValue(false);
    this.transfer.value ? this.destination.enable() : this.destination.disable();
    let transferResponsible = this._transferResponsibleList.find(t => t.value === this._data?.TransferredBy) ?? this._transferResponsibleList[0];
    this.transferResponsible.setValue(transferResponsible);
    let assistence = this._assistanceTypeList.find(a => a.value === this._data?.AssistanceType)?? this._assistanceTypeList[0];
    this.assistanceType.setValue(assistence);
    this.onInput();
  }

  documentChange(){
    let validateFormat = this.validateRUT(this.documentNumber.value)
    clearTimeout(this.debounceAction);
    this.debounceAction = setTimeout(() => {
      if (validateFormat && this.documentNumber.value && this.documentNumber.value?.toString().length > 4 && this.documentType?.value?.label === "RUT") this.onDocumentSearch(this.documentType.value.value, this.documentNumber.value);
    }, 300)
  }

  onDocumentSearch(documentType, documentNumber, useExternal?) {
    if(this.documentNumber.value === this._data.DocumentNumber && this._data?.FirstName && this.editing) {
      this.loadData();
      this.setPersonData(this._data);
      return; 
    }
    this.searchStatus = 1;

    this.coreProxyService.IncidentService.SearchITSPersonRegistration(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      documentType,
      documentNumber,
      useExternal,
      success => {
        this.searchStatus = 0;
        if(!success.DocumentNumber) {
          this._errorMessage = 'Documento no encontrado';
          // this.cleanForm();
          return;
        }
        this._data = JSON.parse(JSON.stringify(success));
        this._data.VehicleDataID = this.vehiclePerson?.value?.value;
        this.setPersonData(this._data);
      },
      err => {
        this.searchStatus = 2;
        this._errorMessage = err.Message;
        this.cleanForm();
        this.appService.showException(err);
      }
    )
  }

  loadData() {
    this.getAssistanceVehicles();
    setTimeout(() => {
      this.getHealthConditions();
      this.getDamageResponsibilities();
      this.loadCountries();
      this.getInsuranceCompanies();
      this.getDocumentTypes();
      this.getPersonTypes();
      this.getPersonAssistanceReasons();
      this.getHospitals();
    }, 200);
  }

  setPersonData(success: ITS_PersonsData) {
    this.name.setValue(success.FirstName);
    this.lastName.setValue(success.LastName);
    this.contactAddress.setValue(success.ContactAddress);
    this.contactCity.setValue(success.ContactCity ? success.ContactCity  : '');
    this.contactPhone.setValue(success.ContactPhone);
    this.insurancePolicy?.setValue(success.InsurancePolicy);
    this.dateFromInsurance?.setValue(success?.InsurancePolicyEffectiveSince);
    this.dateToInsurance?.setValue(success?.InsurancePolicyValidUntil);
    this.email.setValue(success.Email);
    // this.personDescription.setValue(this._data.OtherPersonType);
    this.destination.setValue(this._data.Destination);
    this.loadData();
    setTimeout(() => this.onInput(), 200); 
  }

  resetForm() {
    const country = this._countries.find(c => c.label === 'Chile');
    this.country.setValue(country);
    this.personType.setValue(this._personTypeList[0]);
    this.documentType.setValue(this._documentTypeList[0]);
    this.healthCondition.setValue(this._healthConditionList[0]);
    this.responsible.setValue(this._responsibleList[0]);
    this.assistanceType.setValue(this._assistanceTypeList[0]);
    this.dateFromInsurance?.setValue(null);
    this.dateToInsurance?.setValue(null);
    this.insuranceCompany.setValue(this._insuranceCompanyList[0]);
    this.hospital.setValue(this._hospitalList[0]);
    this.vehiclePerson.setValue(this.vehiclePersonList[0]);
  }

  onClickclearText() {
    this.documentNumber.setValue("");
    this._errorMessage = "";
    this.cleanForm();
    this.searchElementRef?.nativeElement?.focus();
    this._data = { ...new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
  }

  cleanForm() {
    this.name.setValue("");
    this.lastName.setValue("");
    this.contactAddress.setValue("");
    this.contactCity.setValue("");
    this.contactPhone.setValue("");
    this.email.setValue("");
    this.notes.setValue("");
    this.insurancePolicy.setValue("");
    this.destination.setValue("");
    // this.personDescription.setValue("");
    this.country.setValue(this._countries.find(x => x.label === 'Chile'));
    this.insuranceCompany.setValue(this._insuranceCompanyList[0]);
    this.personType.setValue(this._personTypeList[0]);
    this.healthCondition.setValue(this.healthCondition[0]);
    this.responsible.setValue(this._responsibleList[0]);
    this.dateFromInsurance.setValue(null);
    this.dateToInsurance.setValue(null);
    this.hospital.setValue(this._hospitalList[0]);
  }

  async getDocumentTypes() {
    let documents = await this.incidentService.getDocumentTypes();
    this._documentTypeList = this.incidentService._documentTypeList.value;
    let documentType = this._documentTypeList.find(v => v.value === this._data.DocumentTypeID)??this._documentTypeList[0];
    this.documentType.setValue(documentType);
  }
  
  async getInsuranceCompanies(insuranceCompanyID?:number) {
    let insuranceCom, insuranceID, insurance;
    insurance = await this.incidentService.getITSInsuranceCompanies();
    this._insuranceCompanyList = this.incidentService._insuranceCompaniesList.value;
    insuranceCompanyID ? insuranceID = insuranceCompanyID : insuranceID = this._data.InsuranceCompanyID;
    insuranceCom = this._insuranceCompanyList.find(v => v.value === insuranceID)??this._insuranceCompanyList[0];
    this.insuranceCompany.setValue(insuranceCom);
  }

  async getHealthConditions() {
    let healthConditions = await this.incidentService.getHealthConditions();
    this._healthConditionList = this.incidentService._healthConditionList.value;
    let healthCondition = this._healthConditionList.find(v => v.value === this._data?.HealthConditionID)??this._healthConditionList[0];
    this.healthCondition.setValue(healthCondition);
  }
  
  async getDamageResponsibilities() {
    let responsibilities = await this.incidentService.getDamageResponsibilities();
    this._responsibleList = this.incidentService._responsibilitiesList.value;
    let responsibility = this._responsibleList.find(v => v.value === this._data.DamageResponsibilityID)??this._responsibleList[0];
    this.responsible.setValue(responsibility);
  }

  async getPersonTypes() {
    let personTypesList = await this.incidentService.getPersonTypes();
    this._personTypeList = JSON.parse(JSON.stringify(this.incidentService._personTypeList.value));
    let personType = this._personTypeList.find(v => v.value === this._data.PersonTypeID)??this._personTypeList[0];
    this.personType.setValue(personType);
  }  
  
  async getPersonAssistanceReasons() {
    let assistenceTypesList = await this.incidentService.getPersonAssistanceReasons();
    this._assistanceTypeList = this.incidentService._personAssistanceList.value;
    let assistenceTypes = this._assistanceTypeList.find(v => v.value === this._data.AssistanceType)?? this._assistanceTypeList[0];
    this.assistanceType.setValue(assistenceTypes);
  }

  async getHospitals() {
    let hospitalList = await this.incidentService.getITSHospitals();
    this._hospitalList = this.incidentService._hospitalsList.value;
    let  hospital = this._hospitalList.find(v => v.value === this._data.HospitalID)??this._hospitalList[0];
    this.hospital.setValue(hospital);
  }

  async loadCountries() {
    let _countriesFullList = await this.incidentService.loadCountries();
    this._countries = await this.incidentService._countriesList.value;
    let country =  this._countries.find(v => v.value === this._data.CountryID)?? this._countries.find(c => c.label === 'Chile');
    this.country.setValue(country);
  }
  
  async saveInsurance(insuranceName) {
    let insurance = await this.incidentService.createInsuranceCompany(insuranceName);    
    setTimeout(() => {
      this.getInsuranceCompanies(insurance.InsuranceCompanyID);
    }, 200);
  }

  onDateChange(controlName) {
    if((controlName === "dateFromInsurancePerson" || controlName === "dateToInsurancePerson") && this.dateFromInsurance?.value?.Date?.Day) {
      this.minDateInsurance = this.incidentService.setMinDate(this.dateFromInsurance.value);
    }
    
    // if(this.dateFromInsurance?.value && this.dateToInsurance?.value && (this.dateFromInsurance?.value !== this._data?.InsurancePolicyEffectiveSince || this.dateToInsurance?.value !== this._data?.InsurancePolicyValidUntil)) {
    //   this.updatePersonInsurance(this.insuranceCompany?.value, this.insurancePolicy.value);
    // }
    if(controlName === "dateFromInsurancePerson") { this._data.InsurancePolicyEffectiveSince = this.dateFromInsurance?.value; }
    if(controlName === "dateToInsurancePerson") { this._data.InsurancePolicyValidUntil = this.dateToInsurance?.value; }
  }

  getAssistanceVehicles() {
    this._transferResponsibleList = [];
    let optionsList: LabelValue<number>[] = [];
    optionsList.push({ label: 'Sin Determinar', value: 0 });
    this.incidentService._assistanceDispacthList?.forEach(x => {
      let item = { label: x.Movil, value: x.VehicleID ? x.VehicleID : x.ServiceID };
      optionsList.push(item);
    });
    this._transferResponsibleList = optionsList;
  }
  
  updateITSPerson() {
    if(this._data && this._data?.PersonID) {
      clearTimeout(this.debounceUpdate);
      this.debounceUpdate = setTimeout(() => {
        if(!this._data.PersonID) return;
         this.incidentService.updateITSPerson(this._data.PersonID, this._data).then((result) => {
        });
      },300)
    }
  
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validateRUT(rut) {
    let rutLimpio = rut.replace(/[^0-9kK]/g, '');
    const formatValid1 = /^[0-9]{7,8}$/; 
    const formatValid2  = /^[0-9]{7,8}[0-9kK]$/;  // Example: 111111111
    const formatValid3  = /^[0-9]{7,8}-[0-9kK]$/;  // Example: 11111111-1
    const formatValid4  = /^[0-9]{1,2}\.[0-9]{3}\.[0-9]{3}-[0-9kK]$/;  // Example: 11.111.111-1
    if (formatValid1.test(rut) || formatValid2.test(rut) || formatValid3.test(rut) || formatValid4.test(rut)) {
      return true;
    } else {
      return false; 
    }
  }

  get vehiclePerson() { return this.form.get('vehiclePerson'); }
  get documentType() { return this.form.get('documentType'); }
  get documentNumber() { return this.form.get('documentNumber'); }
  get name() { return this.form.get('name'); }
  get lastName() { return this.form.get('lastName'); }
  get contactAddress() { return this.form.get('contactAddress'); }
  get contactCity() { return this.form.get('contactCity'); }
  get contactPhone() { return this.form.get('contactPhone'); }
  get email() { return this.form.get('email'); } 
  get personType() { return this.form.get('personType'); }
  // get personDescription() { return this.form.get('personDescription'); } 
  get country() { return this.form.get('country'); }
  get assistanceType() { return this.form.get('assistanceType'); }
  get healthCondition() { return this.form.get('healthCondition'); }
  get transfer() { return this.form.get('transfer'); }
  get transferResponsible() { return this.form.get('transferResponsible'); }
  get responsible() { return this.form.get('responsible'); }
  get hospital() { return this.form.get('hospital'); }
  get destination() { return this.form.get('destination'); }
  get insuranceCompany() { return this.form.get('insuranceCompany'); }
  get insurancePolicy() { return this.form.get('insurancePolicy'); }
  get dateFromInsurance() { return this.form.get('dateFromInsurance'); }
  get dateToInsurance() { return this.form.get('dateToInsurance'); }
  get notes() { return this.form.get('notes'); }
  
}
